<template>
  <div class="sole_prop_g">
  <PageContent>
    <StepsV2 :step="2" />
    <PanelV2
      type="w6"
      title="Enter your business address"
      @nextClick="commitData"
    >
      <template v-slot:title-solt>
        <BdoProgress :step="2" :total="3" />
      </template>
      <template v-slot:content-solt>
        <div class="radioBox">
          <p class="radioTitle">Same as Home Address</p>
          <BdoRadios :value="sameAasHomeAddress" @onClick="updateRadioValue" />
        </div>
        <AppForm
          ref="appForm"
          v-model="formData"
          :class="isShowArrow"
          :selectOptions="selectOptions"
          :disabled="disabled"
        />
      </template>
    </PanelV2>
  </PageContent>
  </div>
</template>

<script>
  import AppForm from "../forms/SolePropG.val";
  import API from "@/api";
  import {provinceData, cityData} from "../../common-data/config";
  import barangayData from "../../common-data/barangay-data";

  export default {
    name: 'SolePropG',
    pRouter: 'SolePropF',
    components: {
      AppForm,
    },
    data() {

      return {
        homeAddress: {},
        sameAasHomeAddress: '2',
        formData: {},
        status1: true,
        status2: true,
        disabled: false,
        selectOptions: {
          province: provinceData,
          city: [],
          barangay: [],
        }
      }
    },
    created() {
      API.getBdoProcessData({
        pageNo: '3',
        token: this.getCookieItem('token'),
      }).then(res => {
        if (res.success) {
          Object.assign(this.homeAddress, res.obj.homeAddress);
        }
      })
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.appForm.$refs.appForm.clearValidate()
      })
    },
    computed:{
      isShowArrow() {
        if(this.sameAasHomeAddress == 1) {
          return 'isShowArrow'
        } else {
          return ''
        }
      }
    },
    watch: {
      'formData.province': function(val) {
        if (!this.status1) {
          this.$set(this.formData, 'city', '')
        } else {
          this.status1 = false
        }
        this.selectOptions.city = val ? cityData[val] : []
      },
      'formData.city':function(val) {
        if (!this.status2) {
          this.$set(this.formData, 'barangay', '')
        } else {
          this.status2 = false
        }
        this.selectOptions.barangay = barangayData[val || ''] || []
      },
      'formData.barangay':function(val) {
        if (this.selectOptions.barangay.length > 0 && val) {
          const data = this.selectOptions.barangay.filter(value => value.value === val)[0].zipCode
          this.$set(this.formData, 'zipCode', data[0])
        } else {
          this.$set(this.formData, 'zipCode', '')
        }
      },
      sameAasHomeAddress:function(val) {
        if (val == "1") {
          this.disabled = true
        } else {
          this.disabled = false
        }
        this.$nextTick(() => {
          this.$refs.appForm.$refs.appForm.clearValidate()
        })
      }
    },
    methods: {
      updateRadioValue(val) {
        this.sameAasHomeAddress = val;
        this.status1 = true
        this.status2 = true
        this.status3 = true
        if (val === '1') {
          this.$refs.appForm.updateDataForm(this.homeAddress)
        } else {
          this.$refs.appForm.updateDataForm({})
        }
      },
      commitData() {

        this.$refs.appForm.$refs.appForm.validate((valid) => {

          if (valid) {
            const data = this.formatCommitData({...this.formData, sameAasHomeAddress: this.sameAasHomeAddress})

            API.addBdoProcess({
              ...data
            }).then(res => {
              if (res.success) {
                this.toNext()
              }
            })
          }
        });
      }
    }
  }
</script>


<style lang="scss">
.sole_prop_g {
  .panel-v2.content-area .content {
    padding: 32px 0 22px
  }
  .radioBox {
    // border: 1px solid pink;
    // margin-bottom: 40px;
    .radioTitle {
      margin-bottom: 4px;
      font-size: 16px;
      color: #2e2e2e;
      // font-family: Nunito;
    }
  }
  .isShowArrow {
    span.el-input__suffix {
      display: none;
    }
  }
  .el-form-item {
    &:nth-child(6) {
      width: 26% !important;
    }
    &:nth-child(7) {
      width: 18% !important;
    }
  }
}
</style>
